export const langText: any = {
    us: {
        price1_front: '限定価格：',
        price2_front: '通常価格：',
        link_more: 'Learn More',
        link_buy: 'Buy Now',
        sold_out: 'Sold Out',
    },
    jp: {
        price1_front: '限定価格：',
        price2_front: '通常価格：',
        link_more: 'さらに詳しく',
        link_buy: '今すぐ購入',
        sold_out: '完売',
    },
};
